import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/Production",
      name: "production",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Products.vue"),
    },
    {
      path: "/Contact",
      name: "contact",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Contact.vue"),
    },
    {
      path: "/Samples",
      name: "samples",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Examples.vue"),
    },
    {
      path: "/Assembly",
      name: "assembly",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Assembly.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})
